import {trimValue} from '../utilities/utilities';
import WindowMetrics from '../utilities/window-metrics';
import ScrollAnimation from './scroll-animation';

const settings = {
    cssProperties: {
        desktopVisibilityProgress: '--chair-gallery-scroll-progress',
    },

    classNames: {
        container: 'chair-gallery-section',
    },

    // Threshold at which we show the images on desktop
    imageAppearanceThresholdDesktop: 0.125,

    // Delay between image appearances on desktop, in seconds
    imageAppearanceDelayDesktop: 0.125,
};

export default class ChairGallerySection extends ScrollAnimation {
    constructor(container) {
        // Call base class
        super(container);

        // Flag indicating whether our images are visible on desktop
        this.imagesVisible = false;

        // Find our images, which are animated by applying a class
        // via javascript on desktop vs. leveraging the default
        // ScrollAnimation functionality like on mobile
        this.images = container.querySelectorAll('ul > li figure img');
    }

    static init() {
        // Find elements with the expected class name
        const elements = document
            .getElementsByClassName(settings.classNames.container);

        for (let i=0; i<elements.length; i++) {
            new ChairGallerySection(elements[i]);
        }
    }
    /**
     * Signals that we should update our position within the animation
     * @param {number} overallProgress
     * @param {number} topProgress
     * @param {number} centerProgress
     */
    setAnimationProgress(
        overallProgress,
        topProgress,
        centerProgress,
    ) {
        // Stop here if we're in mobile
        if (WindowMetrics.isMobile()) {
            // Call base class
            super.setAnimationProgress(
                overallProgress,
                topProgress,
                centerProgress,
            );

            return;
        }

        // Check if our images should be visible
        const newImagesVisible = (
            centerProgress >= settings.imageAppearanceThresholdDesktop
        );

        // Stop here if there hasn't been a change in whether
        // or not our images should be visible
        if (newImagesVisible == this.imagesVisible) {
            return;
        }

        this.imagesVisible = newImagesVisible;

        // Stop any ongoing animation
        if (this.imageShowHideTimeline) {
            this.imageShowHideTimeline.progress(1);
        }

        this.imageShowHideTimeline = gsap.timeline();

        if (this.imagesVisible) {
            // Show our images
            for (let i=0; i<this.images.length; i++) {
                const image = this.images[i];
                const progress = {
                    percentComplete: 0,
                };

                this.imageShowHideTimeline.to(
                    progress,
                    1,
                    {
                        ease: 'power1.inOut',
                        percentComplete: 1,
                        onUpdate: () => {
                            image.style.setProperty(
                                settings
                                    .cssProperties
                                    .desktopVisibilityProgress,
                                trimValue(progress.percentComplete),
                            );
                        },
                    },
                    i * settings.imageAppearanceDelayDesktop,
                );
            }
        } else {
            // Hide our images
            for (let i=0; i<this.images.length; i++) {
                const image = this.images[i];
                const progress = {
                    percentComplete: 1,
                };

                this.imageShowHideTimeline.to(
                    progress,
                    0.25,
                    {
                        ease: 'power1.out',
                        percentComplete: 0,
                        onUpdate: () => {
                            image.style.setProperty(
                                settings
                                    .cssProperties
                                    .desktopVisibilityProgress,
                                trimValue(progress.percentComplete),
                            );
                        },
                    },
                    0,
                );
            }
        }

        this.imageShowHideTimeline.add(
            function() {
                this.imageShowHideTimeline = null;
            }.bind(this),
        );
    }
}
